import { render } from "./BDDashboard.vue?vue&type=template&id=5e3e0766&scoped=true"
import script from "./BDDashboard.vue?vue&type=script&lang=js"
export * from "./BDDashboard.vue?vue&type=script&lang=js"

import "./BDDashboard.vue?vue&type=style&index=0&id=5e3e0766&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3e0766"]])

export default __exports__